module.exports = __webpack_public_path__ + "assets/img/example2.801287db.png";